import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import * as discountCodesActions from '../../../redux/discountCodes/actions';
import submitForm from '../../../utils/submitForm';
import Spin from '../../../components/loading';
import Pagination2 from '../../../components/Pagination2';
import DiscountCodeUsersFilter from './discountCodesUsersFilter';
import { discountCodeUsersCol } from '../../../enums/columns/discountCodeUsersCol';
import Table from '../../../components/table';

class discountCodeUsers extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPage: 1,
      query: '',
      sortType: 'asc',
      sortBy: 'usedAt',
      itemsPerPage: 20,
      selectedCafeReservationDetailsId: -1,
    };
  }

  componentDidMount() {
    if (this.props.location.discountCodeId) {
      this.sortTable(this.state.sortBy);
    } else {
      this.props.history.push('/discount-codes');
    }
  }

  closeCafeReservationDetailsModal = () => {
    this.setState(() => ({
      cafeReservationDetailsOpen: false,
    }));
  };

  displayCafeReservationDetailsModal = id => {
    this.setState({
      cafeReservationDetailsOpen: true,
      selectedCafeReservationDetailsId: id,
    });
  };

  applyFilters = event => {
    event.preventDefault();
    const queryString = submitForm(
      event,
      this.state.selectedRegions,
      this.state.selectedAmenities,
    );
    this.setState({ filter: queryString }, () => this.filterAndSort());
  };

  filterAndSort = () => {
    let { filter, sort } = this.state;
    let query;
    if (sort && filter) query = `${filter}&${sort}`;
    else if (filter) query = `${filter}`;
    else if (sort) query = `${sort}`;
    this.setState({ query, currentPage: 1 }, () => {
      let searchQuery = this.buildSearchQuery(
        this.state.currentPage,
        this.state.itemsPerPage,
      );
      this.props.fetchAllDiscountCodeUsers(
        this.props.location.discountCodeId,
        searchQuery,
      );
    });
  };

  renderStatusColors = status => {
    switch (status) {
      case 'OPEN':
        return 'text-info';
      case 'CLOSE':
        return 'text-scondary';
      case 'SUSPENDED':
        return 'text-warning';
      case 'STARTED':
        return 'text-info';
      case 'APPROVED':
        return 'text-success';
      default:
        return 'text-muted';
    }
  };

  buildSearchQuery = (pageNumber, pageSize) => {
    if (!isNaN(pageNumber) && !isNaN(pageSize)) {
      let query = `pageNumber=${pageNumber}&pageSize=${pageSize}`;
      query += `&${this.state.query || 'sort=usedAt-desc'}`;
      return query;
    }
  };

  onPageChanged = currentPage => {

    this.setState({ currentPage: currentPage }, () => {
      const query = this.buildSearchQuery(
        this.state.currentPage,
        this.state.itemsPerPage,
      );
      this.props.fetchAllDiscountCodeUsers(
        this.props.location.discountCodeId,
        query,
      );
    });
  };

  sortTable = query => {
    this.applySort(query);
  };

  applySort = query => {
    this.setState(
      { sortType: this.state.sortType === 'asc' ? 'desc' : 'asc' },
      () => {
        query = `${query}-${this.state.sortType}`;
        this.setState({ sort: `sort=${query}` }, () => this.filterAndSort());
      },
    );
  };

  render() {
    let {
      discountCodeUsersList = [],
      loading,
      discountCodeUsers,
      error,
      message,
      failed,
    } = this.props;

    let { totalRecords } = discountCodeUsers;
    let { currentPage, itemsPerPage, sortType } = this.state;

    return (
      <>
        <section className='page-header'>
          <h3 className='p-3 text-right text-muted'>
            {locales('titles.discountsUsers', {
              fieldName: `${this.props.location.title}  ${locales(
                'titles.fromTime',
              )} ${this.props.location.validFrom} ${locales('fields.to')} ${this.props.location.validTo
                }`,
            })}
          </h3>
          <div className='form-actions d-flex align-items-center'>
            <Link to='/discount-codes' className='btn btn-default'>
              <i className='fa fa-reply' />
              {locales('labels.cancel')}
            </Link>
          </div>
        </section>
        <Spin spinning={loading}>
          {error && (
            <div className='alert alert-danger'>
              {locales('messages.server.error')}
            </div>
          )}
          {failed && <div className='alert alert-danger'>{message}</div>}
          <div className='panel-heading'>
            <i className='fas fa-list-alt px-1' />
            {locales('titles.discountCodeUsersList')}
          </div>
          <div className='panel-body'>
            <DiscountCodeUsersFilter applyFilters={this.applyFilters} />
            <Table
              columns={discountCodeUsersCol}
              dataSource={discountCodeUsersList}
              loading={loading}
              sort={{ type: sortType, action: this.sortTable }}
              pagination={{
                currentPage: currentPage,
                pageSize: itemsPerPage,
                totalCount: totalRecords,
                onPageChange: this.onPageChanged,
              }}
            />
          </div>
        </Spin>
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    discountCodeUsersList: state.discountCodesReducer.discountCodeUsersList,
    discountCodeUsers: state.discountCodesReducer.discountCodeUsers,
    loading: state.discountCodesReducer.discountCodeUsersLoading,
    error: state.discountCodesReducer.discountCodeUsersError,
    message: state.discountCodesReducer.discountCodeUsersMessage,
    failed: state.discountCodesReducer.discountCodeUsersFailed,
    totalRecords: state.discountCodesReducer.totalRecords,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchAllDiscountCodeUsers: (id, query) =>
      dispatch(discountCodesActions.fetchAllDiscountCodeUsers(id, query)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(discountCodeUsers),
);
